module.exports = __webpack_public_path__ + "static/media/app-5.4ff2dccc.jpg";